import Card, { SectionHeading } from "../../components/Card";
import CoreLayout from "../../components/layout/CoreLayout";
import PageContainer from "../../components/PageContainer";
import PageHeader from "../../components/PageHeader";
import { usePageTitle } from "../../lib/usePageTitle";

const PLAN = {
  name: "Early Access",
  price: "Custom pricing",
  status: "Active",
};

const SUPPORT_EMAIL = "support@neurospherevoiceai.com";

export default function Billing() {
  usePageTitle("Billing");
  return (
    <CoreLayout>
      <PageContainer>
        <PageHeader
          title="Billing"
          subtitle="Your plan, payments, and invoices."
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Card>
            <SectionHeading icon="ri-vip-crown-line">Current plan</SectionHeading>
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="text-2xl font-bold text-white">{PLAN.name}</div>
                <div className="text-sm text-gray-400 mt-1">{PLAN.price}</div>
              </div>
              <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-500/15 text-green-400 border border-green-500/30">
                {PLAN.status}
              </span>
            </div>
            <p className="text-sm text-gray-400">
              Plan changes are handled by our team during early access. Email
              us and we&apos;ll take care of it.
            </p>
          </Card>

          <Card>
            <SectionHeading icon="ri-bank-card-line">Payment</SectionHeading>
            <p className="text-sm text-gray-400 mb-4">
              During early access, billing is handled directly by our team.
              You&apos;ll receive invoices by email — nothing is charged
              automatically.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}?subject=Billing%20question`}
              className="inline-block w-full text-center py-3 rounded-lg font-semibold text-white transition-all"
              style={{
                background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
              }}
            >
              Email billing support
            </a>
          </Card>

          <Card>
            <SectionHeading icon="ri-file-list-3-line">Invoices</SectionHeading>
            <div className="flex flex-col items-center justify-center py-8 text-center">
              <i className="ri-inbox-line text-3xl text-gray-500 mb-3" />
              <p className="text-sm text-gray-400">
                No invoices yet. Your first invoice will appear here after your
                first billing cycle.
              </p>
            </div>
          </Card>

          <Card>
            <SectionHeading icon="ri-customer-service-2-line">Billing contact</SectionHeading>
            <p className="text-sm text-gray-400 mb-2">
              Questions about your plan, an invoice, or pricing?
            </p>
            <p className="text-sm">
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="text-purple-400 hover:text-purple-300"
              >
                {SUPPORT_EMAIL}
              </a>
            </p>
          </Card>
        </div>
      </PageContainer>
    </CoreLayout>
  );
}
